import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    dashboard: {
      sidebar: {
        background: '#0c66ab', // Primary brand blue
        border: '1px solid rgba(203, 214, 224, 0.5)', // Increased border contrast
        hoverBg: 'rgba(255, 255, 255, 0.15)', // More visible hover
        text: '#ffffff',
        activeBg: 'rgba(255, 255, 255, 0.25)', // Brighter active state
        icon: '#ffffff', // Explicit icon color
      },
      avatar: {
        border: '2px solid #cbd6e0', // Light slate border
      },
      userMenu: {
        hoverBg: 'rgba(12, 102, 171, 0.1)', // Light accent blue for hover
      },
      content: {
        shadow: '0 4px 24px rgba(12, 102, 171, 0.15)', // Brand blue shadow
      },
    },
    primary: {
      main: '#0c66ab', // Brand blue as primary
      dark: '#21334a', // Dark navy for contrast
      light: '#cbd6e0', // Light slate for backgrounds
    },
    secondary: {
      main: '#21334a', // Navy as secondary
      light: '#4a5b73', // Medium slate for text
    },
    background: {
      default: '#f8faff', // Light blue tint
      paper: '#ffffff', // Pure white surfaces
    },
    text: {
      primary: '#21334a', // Navy for main text
      secondary: '#4a5b73', // Medium slate for subtitles
      disabled: '#a3b1c5', // Light slate for disabled states
      white: '#ffffff', // White text
    },
    action: {
      hover: 'rgba(12, 102, 171, 0.05)', // Subtle blue hover
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 800, // Increased weight for better contrast
      color: '#21334a',
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '1.625rem', // Slightly larger
      fontWeight: 700,
      color: '#0c66ab',
      borderBottom: '3px solid #cbd6e0', // Thicker border
      paddingBottom: '0.5rem',
    },
    body1: {
      color: '#4a5b73',
      lineHeight: 1.6,
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.025em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '10px 20px', // Reduced padding
          transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&.MuiButton-nav': {
            borderRadius: '6px',
            margin: '2px 0', // Reduced margin
            padding: '8px 12px', // Added padding
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
              transform: 'translateX(4px)', // Reduced movement
              '& svg': {
                transform: 'scale(1.05)', // Reduced scaling
              },
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          border: '1px solid #cbd6e0',
          transition: 'all 0.25s ease',
          boxShadow: '0 4px 16px rgba(12, 102, 171, 0.1)', // Stronger shadow
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(12, 102, 171, 0.2)', // More pronounced hover
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          border: '2px solid #cbd6e0',
          backgroundColor: '#0c66ab',
          color: '#ffffff',
          boxShadow: '0 2px 8px rgba(12, 102, 171, 0.3)', // Better visibility
          '&:hover': {
            boxShadow: '0 0 12px rgba(12, 102, 171, 0.2)',
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '40px', // Increased spacing
          color: '#ffffff', // Directly using the color
          '& svg': {
            fontSize: '1.5rem', // Larger icons
            transition: 'transform 0.2s ease',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.nav-item': {
            fontWeight: 600,
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.15)', // Text shadow for better contrast
            '&::after': {
              backgroundColor: '#ffffff', // White underline effect
            },
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#21334a',
          color: '#ffffff',
          fontSize: '0.875rem',
          fontWeight: 500,
          padding: '6px 12px',
          borderRadius: '6px',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;